function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.3536 2.35354C19.1583 2.15828 18.8417 2.15828 18.6464 2.35354L12.1464 8.85354C12.0527 8.94731 12 9.07448 12 9.20709V11.5C12 11.7761 12.2239 12 12.5 12H14.7929C14.9255 12 15.0527 11.9473 15.1464 11.8535L21.6464 5.35354C21.8417 5.15828 21.8417 4.84169 21.6464 4.64643L19.3536 2.35354ZM19 3.49999L13 9.49999V11H14.5L20.5 4.99999L19 3.49999ZM15.1464 3.85354L13.1464 5.85354C13.0527 5.94731 12.9255 5.99998 12.7929 5.99998H6.5C6.22386 5.99998 6 6.22384 6 6.49998V17.5C6 17.7761 6.22386 18 6.5 18H17.5C17.7761 18 18 17.7761 18 17.5V11.2071C18 11.0745 18.0527 10.9473 18.1464 10.8535L20.1464 8.85354C20.4614 8.53856 21 8.76164 21 9.20709V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V3.99999C3 3.4477 3.44772 2.99998 4 2.99998H14.7929C15.2383 2.99998 15.4614 3.53856 15.1464 3.85354Z"
});

var SvgNewPost = function SvgNewPost(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewPost, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/NewPost.264c0187.svg";
export { ForwardRef as ReactComponent };